import { Component } from '@angular/core';

import { ContainerComponent } from '../../../shared/components/container/container.component';
import { DecoratorComponent } from '../../../shared/components/decorator/decorator.component';

@Component({
  selector: '[why-screen]',
  imports: [ContainerComponent, DecoratorComponent],
  templateUrl: './why-screen.component.html',
  styleUrl: './why-screen.component.scss',
  host: {
    class: 'bg-gray-800 position-relative z-0',
    id: 'benefits-of-knowing'
  }
})
export class WhyScreenComponent {
  decorator = {
    firstLineColor: '#9657d6',
    secondLineColor: '#ff5e2b'
  }
}
